/**
 * @generated SignedSource<<7729ab528fc8458d84f800b1ec4bf79a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type MercuryRiskTargetDateType = "DAY" | "MONTH" | "QUARTER" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "code" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "organization" | "organization_status_update" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "risk" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchMercuryRisk_AtlassianSearchPage$data = {
  readonly __typename: string;
  readonly id: string;
  readonly lastModifiedDate?: string | null;
  readonly risk?: {
    readonly status: {
      readonly displayName: string;
      readonly key: string;
    } | null;
    readonly targetDate: {
      readonly targetDate: string;
      readonly targetDateType: MercuryRiskTargetDateType;
    } | null;
  } | null;
  readonly title: string;
  readonly type: SearchResultType;
  readonly url: string;
  readonly " $fragmentType": "searchMercuryRisk_AtlassianSearchPage";
};
export type searchMercuryRisk_AtlassianSearchPage$key = {
  readonly " $data"?: searchMercuryRisk_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchMercuryRisk_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchMercuryRisk_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "lastModifiedDate"
        },
        {
          "concreteType": "MercuryRisk",
          "kind": "LinkedField",
          "name": "risk",
          "plural": false,
          "selections": [
            {
              "concreteType": "MercuryRiskStatus",
              "kind": "LinkedField",
              "name": "status",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "key"
                },
                {
                  "kind": "ScalarField",
                  "name": "displayName"
                }
              ]
            },
            {
              "concreteType": "MercuryRiskTargetDate",
              "kind": "LinkedField",
              "name": "targetDate",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "targetDate"
                },
                {
                  "kind": "ScalarField",
                  "name": "targetDateType"
                }
              ]
            }
          ]
        }
      ],
      "type": "SearchResultMercuryRisk"
    }
  ],
  "type": "SearchResult",
  "abstractKey": "__isSearchResult"
};

(node as any).hash = "7dcfacdab9fc21c27b97589d62520136";

export default node;
